import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/gaushala/donations";

export const Route = createFileRoute("/admin/_gaushala/gaushala-donations")({
  component: Page,
});
